import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RateAdminRatePlanScreen from "../../../container/RateAdminScreen/RateAdminRatePlanScreen";
import CreateRateAdminRatePlan from "../../../container/RateAdminScreen/RateAdminRatePlanScreen/CreateRateAdminRatePlan";

const RateAdminRatePlanRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_RATE_PLAN.HOME}
          element={
            <RateAdminRatePlanScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_RATE_PLAN.CREATE}
          element={<CreateRateAdminRatePlan />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RATEADMIN_RATE_PLAN.EDIT}
          element={<CreateRateAdminRatePlan isEdit={true} />}
        />
      )}
    </>
  );
};

export default RateAdminRatePlanRoutes;
